<div  *ngIf="IsLoad === false" mat-dialog-content class="text-center">
  {{data.element.confirmation_popup}}
</div>
<div mat-dialog-actions class="row justify-content-center mt-3 mb-2">

  <button *ngIf="IsLoad === false" [ngClass]="{'recharge-gradien': data.book.type === 0 ||data.book.type === 7,  'autopartage-gradien':data.book.type === 1}"
    mat-raised-button class="btn mr-2"  tabindex="-1" color="primary" (click)="onConfirm()">{{ 'CONFIRMERESERVATION.BOUTONOUI' |
    translate }}</button>
  <button *ngIf="IsLoad === false" [ngClass]="{'recharge-gradien': data.book.type === 0 || data.book.type === 7,  'autopartage-gradien': data.book.type === 1}"
    mat-raised-button class="btn ml-2"  tabindex="-1"  color="primary" (click)="onNoClick()">{{
    'CONFIRMERESERVATION.BOUTONNON' | translate }}</button>

      <!-- spinner -->
      <div *ngIf="IsLoad === true" class="col-12 mt-3 mb-5 spinner">
        <div class="row justify-content-center mt-4">
          <mat-spinner  [ngClass]="{'recharg': data.book.type === 0 ||data.book.type === 7,  'autopar':data.book.type === 1}"
          class="mt-5" strokeWidth="19" [diameter]="100" ></mat-spinner>
        </div>
      </div>

</div>